<template>
  <section>
    <h1 class="center m1">Meus Cursos</h1>
    <div class="flex flex-row flex-wrap">
      <div
        class="col-12 sm-col-6 p1 flex flex-column"
        v-for="record in $dados.MATRICULAS"
        :key="record.ID"
      >
        <div class="flex-auto flex flex-column p1 bg-white border border-gray">
          <h2 class="m1">{{record.ID}} - {{record.CURSO}}</h2>
          <h3 class="m1">Válido até: {{record.VALIDOATE | date}}</h3>
          <div class="flex-auto"></div>
          <div class="px-2">
            <span
              class="btn btn-primary"
              @click="acessar(record)"
            >
              acessar
            </span>
          </div>
        </div>
        {{record.IDCURSO}}
      </div>
    </div>
  </section>
</template>

<script>
var componentDefinition = {
  route: {
    path: '/aluno/:idaluno',
    meta: {
      title: 'Matrículas'
    }
  },
  methods: {
    acessar: function (record) {
      var route = {
        name: 'MODULOS',
        params: {
          idaluno: record.IDALUNO,
          idmatricula: record.ID
        }
      }
      this.$router.push(route)
    },
    comprar: function (id) {
      var promise = this.$requests.post([
        '/SATACS/ALUNO',
        this.$route.params.idaluno,
        'CURSOS',
        id
      ].join('/'))
      promise.then(response => {
        // this.$dados.MATRICULAS.splice(this.$dados.MATRICULAS.length, 0, response.data.record)
        this.$dados.MATRICULAS.push(response.data.record)
        var route = {
          name: 'MODULOS',
          params: {
            idaluno: this.$route.params.idaluno,
            idmatricula: response.data.id
          }
        }
        this.$router.push(route)
      })
    }
  }
}
export default componentDefinition
</script>
